module.exports = __webpack_public_path__ + "static/Cockatrice-93a85db589d0b5857a1f4b639f41ecf4.jpg";